<template>
  <a-modal
    title="开通你的配置资格"
    :visible="visible"
    :width="560"
    :footer="null"
    destroyOnClose
    wrapClassName="related-account-create-dialog"
    @cancel="handleClose"
  >
    <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
      <a-form-model-item
        label="迪士尼 OTE 接口 baseUrl"
        prop="baseUrl"
      >
        <a-input
          v-model="form.baseUrl"
          placeholder="如 https://xxx.hongkongdisneyland.com/ota"
          allow-clear
        />
      </a-form-model-item>

      <a-form-model-item label="agentId" prop="agentId">
        <a-input v-model="form.agentId" placeholder="请输入 agentId" allow-clear />
      </a-form-model-item>

      <a-form-model-item
        label="secretKey"
        prop="secretKey"
      >
        <a-input-password
          v-model="form.secretKey"
          placeholder="请输入 secretKey"
        />
        <!-- :visibilityToggle="false"  小眼睛 -->
      </a-form-model-item>

      <a-form-model-item label="备注 (可选)" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" allow-clear />
      </a-form-model-item>
    </a-form-model>

    <div class="footer-divider" />

    <a-button
      type="primary"
      block
      size="large"
      :loading="submitting"
      @click="handleSubmit"
    >
      开通
    </a-button>
  </a-modal>
</template>

<script>
const DEFAULT_FORM = () => ({
  baseUrl: '',
  agentId: '',
  secretKey: '',
  remark: ''
})

export default {
  name: 'RelatedAccountCreateDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      form: DEFAULT_FORM(),
      rules: {
        baseUrl: [{ required: true, message: '请输入 baseUrl', trigger: 'blur' }],
        agentId: [{ required: true, message: '请输入 agentId', trigger: 'blur' }],
        secretKey: [{ required: true, message: '请输入 secretKey', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = DEFAULT_FORM()
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate()
        })
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    /**
     * POST /hkdl/config/admin/managers
     * merchantId 由后端按登录态强写，前端不传
     * baseUrl/agentId/secretKey 仅连通性测试，不落库
     */
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const params = {
          merchantId: this.$store.getters.userInfo.merchantId,
          status: 1,
          markupPoints: 0,
          flatFen: 0,
          baseUrl: (this.form.baseUrl || '').trim(),
          agentId: (this.form.agentId || '').trim(),
          secretKey: this.form.secretKey || '',
          remark: (this.form.remark || '').trim()
        }
        this.submitting = true
        this.getHttpServices()
          .getSourceService()
          .post('/hkdl/config/admin/managers', params)
          .then(() => {
            this.$message.success('开通成功')
            this.handleClose()
            this.$emit('success')
          })
          .catch(err => {
            this.$message.error((err && err.msg) || '开通失败，请重试')
          })
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>
